import { Toast } from 'vant';

let needLoadingRequestCount = 0

function startLoading () {
  Toast.loading({
    duration: 0,
    forbidClick: true,
    message: '加载中...'
  })
}

function endLoading () {
  Toast.clear()
}

export function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    setTimeout(tryCloseLoading, 300)
  }
}

export function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

const tryCloseLoading = () => {
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}
